module.exports = __webpack_public_path__ + "static/img/rank_94.02b02a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_94.png
// module id = xe4n
// module chunks = 1